import { useQuery } from "@tanstack/react-query";
import type { DashboardParams } from "./client";
import { dashboardApi } from "./client";

function serializeParams(params?: DashboardParams) {
  if (!params) return undefined;
  return {
    ...params,
    fromDate: params.fromDate?.toISOString(),
    toDate: params.toDate?.toISOString(),
    branchId: params.branchId,
  };
}

export const dashboardKeys = {
  all: ["dashboard"] as const,
  kpi: (params?: DashboardParams) =>
    [...dashboardKeys.all, "kpi", serializeParams(params)] as const,
  charts: (params?: DashboardParams) =>
    [...dashboardKeys.all, "charts", serializeParams(params)] as const,
  tables: (params?: DashboardParams) =>
    [...dashboardKeys.all, "tables", serializeParams(params)] as const,
  alerts: (params?: DashboardParams) =>
    [...dashboardKeys.all, "alerts", serializeParams(params)] as const,
};

export function useDashboardKPIQuery(params?: DashboardParams) {
  return useQuery({
    queryKey: dashboardKeys.kpi(params),
    queryFn: () => dashboardApi.getKPIData(params),
  });
}

export function useDashboardChartsQuery(params?: DashboardParams) {
  return useQuery({
    queryKey: dashboardKeys.charts(params),
    queryFn: () => dashboardApi.getChartData(params),
  });
}

export function useDashboardTablesQuery(params?: DashboardParams) {
  return useQuery({
    queryKey: dashboardKeys.tables(params),
    queryFn: () => dashboardApi.getTableData(params),
  });
}

export function useDashboardAlertsQuery(params?: DashboardParams) {
  return useQuery({
    queryKey: dashboardKeys.alerts(params),
    queryFn: () => dashboardApi.getAlertData(params),
  });
}
